import styles from './Loading.module.css'

export const Loading = () => {
  return (
    <div className={styles.container} data-testid="loading-container">
      <div className={styles.text} data-testid="loading-text">
        Loading...
      </div>
      <div className={styles.line} data-testid="loading-line" />
    </div>
  )
}
